const SET_STUDENT_NEW_STATUS = "SET_STUDENT_NEW_STATUS";
const SET_STUDENT_FIRST_NAME = "SET_STUDENT_FIRST_NAME";
const SET_STUDENT_LAST_NAME = "SET_STUDENT_LAST_NAME";
const SET_STUDENT_ID = "SET_STUDENT_ID";
const SET_STUDENT_COURSE_CODE = "SET_STUDENT_COURSE_CODE";
const SET_STUDENT_LOGGED_IN = "SET_STUDENT_LOGGED_IN";
const ADD_NEW_STUDENT = "ADD_NEW_STUDENT";

const SET_PROF_EMAIL = "SET_PROF_EMAIL";
const SET_PROF_PASSWORD = "SET_PROF_PASSWORD";
const SET_LOGGED_IN_PROF = "SET_LOGGED_IN_PROF";
const SET_PROF_LOG_OUT = "SET_PROF_LOG_OUT";

const SET_SELECTED_COURSE = "SET_SELECTED_COURSE";
const SET_SEARCH_TERM = "SET_SEARCH_TERM";
const SET_SEARCH_RESULTS = "SET_SEARCH_RESULTS";
const SET_SELECTED_STUDENT = "SET_SELECTED_STUDENT";

export {
	SET_STUDENT_NEW_STATUS,
	SET_STUDENT_FIRST_NAME,
	SET_STUDENT_LAST_NAME,
	SET_STUDENT_ID,
	SET_STUDENT_COURSE_CODE,
	SET_STUDENT_LOGGED_IN,
	ADD_NEW_STUDENT,
	SET_PROF_EMAIL,
	SET_PROF_PASSWORD,
	SET_LOGGED_IN_PROF,
	SET_PROF_LOG_OUT,
	SET_SELECTED_COURSE,
	SET_SEARCH_TERM,
	SET_SEARCH_RESULTS,
	SET_SELECTED_STUDENT,
};
